<template>
  <div>
    <div class="device_details">
      <div class="imgDiv">
        <img :src="imgUrl" v-if="imgUrl" />
        <img
          class="default_img"
          src="../../public/image/defaultImage.png"
          v-else
        />
      </div>
      <div
        class="device_info"
        v-for="(item, index) in deviceInfoArr"
        :key="index"
      >
        <span class="title">{{ item.name }} </span>
        <!-- <template v-if="item.name === 'Status'">
          <span class="content" :class="'status_' + item.value">{{
            item.value != null ? item.value : "-"
          }}</span>
        </template> -->
        <span class="content">{{ item.value != null ? item.value : "-" }}</span>
      </div>

      <div class="device_info">
        <span class="title">RFID </span>
        <span class="content">{{ IdObj.RFID }}</span>
      </div>
    </div>
    <div class="linkBtn">
      <Button
        v-for="(ite, ind) in linkBtnArr"
        :key="ind"
        class="linkBtnItem"
        :style="setBtnBg(ind)"
        @click="linkTo(ite.path)"
      >
        <Icon type="ios-link" />
        {{ ite.desc }}
      </Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeviceDetails",
  props: {
    deviceDetailsObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    deviceDetailsObj(obj) {
      // console.log(obj);
      this.initDeviceDetails(obj);
    },
  },
  data() {
    return {
      deviceInfoArr: [
        {
          name: "System",
          key: "systemName",
          value: "",
        },
        {
          name: "Location",
          key: "locationName",
          value: "",
        },
        {
          name: "Type",
          key: "typeName",
          value: "",
        },
        {
          name: "Description",
          key: "description",
          value: "",
        },
        // {
        //   name: "Status",
        //   key: "status",
        // },
        {
          name: "Brand",
          key: "brand",
          value: "",
        },
        {
          name: "Material",
          key: "material",
          value: "",
        },
        {
          name: "Remarks",
          key: "remarks",
          value: "",
        },
        {
          name: "BIM_ID",
          key: "bimid",
          value: "",
        },
      ],
      linkBtnArr: [],
      colorList: [
        "#ED7B2F",
        "#0976F5",
        "#E34D59",
        "#00A870",
        "#0025A8",
        "#C8009C",
        "#8F8A06",
      ],
      IdObj: {
        BIM_ID: "",
        RFID: "",
      },
      imgUrl: "",
    };
  },
  methods: {
    setBtnBg(index) {
      if (index < this.colorList.length) {
        return { color: this.colorList[index] };
      }
      return { color: this.colorList[index - this.colorList.length] };
    },
    linkTo(path) {
      if (path.includes("http")) {
        window.open(path, " _blank");
      } else {
        window.open(`http://${path}`, " _blank");
      }
    },
    getFileFun(key) {
      window.AWS_S3_FUNCTIONS.GET_IMG_FILE(key)
        .then((res) => {
          if (res.isSuccess) {
            this.imgUrl = res.data;
          } else {
            this.imgUrl = "";
          }
        })
        .catch((e) => {
          this.$Message.error(e.err.message);
        });
    },
    // 初始化数据
    initDeviceDetails(obj) {
      if (this.deviceDetailsObj.image) {
        this.getFileFun(this.deviceDetailsObj.image);
      } else {
        this.imgUrl = "";
      }
      Object.keys(obj).forEach((key) => {
        Object.entries(this.deviceInfoArr).forEach(([, _item]) => {
          const item = _item;
          if (key === item.key) {
            // // console.log(obj[key]);
            item.value = obj[key];
          }
        });
      });
      // // console.log(this.deviceInfoArr);
      const { deviceDetailsObj } = this;
      let tempArr = deviceDetailsObj.document;
      const tempObj = JSON.parse(deviceDetailsObj.attributes);
      // // console.log(tempObj);
      this.IdObj = {
        RFID: "",
      };
      this.linkBtnArr = [];
      if (tempArr && tempArr.length > 0) {
        tempArr = JSON.parse(deviceDetailsObj.document);
        Object.entries(tempArr).forEach(([, item]) => {
          if (item.path) {
            const row = {
              desc: item.desc,
              path: item.path,
            };
            this.linkBtnArr.push(row);
          }
        });
        // // console.log(this.linkBtnArr);
      }
      Object.keys(tempObj).forEach((k) => {
        Object.entries(this.IdObj).forEach(([idKey]) => {
          if (k === idKey) {
            this.IdObj[idKey] = tempObj[k];
          }
        });
      });
      // console.log(this.IdObj);
    },
  },
};
</script>

<style lang="less">
.device_details {
  padding: 0 40px 0 90px;
  .imgDiv {
    height: 168px;
    width: 270px;
    margin: 0 auto;
    margin-bottom: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
    .default_img {
      object-fit: cover;
      object-position: top;
    }
  }
  .device_info {
    display: flex;
    margin-bottom: 20px;
    .title {
      display: inline-block;
      width: 120px;
      text-align: left;

      color: #727272;
    }
    .content {
      color: #171717;
      flex: 1;
    }
  }
}
.linkBtn {
  text-align: center;
}
.linkBtnItem.ivu-btn {
  margin: 4px;
  background: #f2f2f2;
  border-radius: 2px;
  border: none;
}
.status_Fault {
  color: #ed7b2f !important;
}
.status_Normal {
  color: #00a870 !important;
}
</style>
